import { render, staticRenderFns } from "./ProofDetailsDialog.vue?vue&type=template&id=75986523"
import script from "./ProofDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ProofDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports